import { render, staticRenderFns } from "./AddIndexer.vue?vue&type=template&id=f039d886&scoped=true"
import script from "./AddIndexer.vue?vue&type=script&lang=js"
export * from "./AddIndexer.vue?vue&type=script&lang=js"
import style0 from "./AddIndexer.vue?vue&type=style&index=0&id=f039d886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f039d886",
  null
  
)

export default component.exports